import { ICustomerDisplayDevice } from '../../ICustomerDisplayDevice';
import { UniversalCustomerDisplayDevice, SavedDeviceInfo as SavedDeviceInfoBase } from '../UniversalCustomerDisplayDevice';
import { NetworkDriver } from './NetworkDriver';

export class Device extends UniversalCustomerDisplayDevice<ConnectionInfo> {
  createDriver() {
    return new NetworkDriver(this, this.loggerFactory);
  }

  override loadFrom(device: ICustomerDisplayDevice) {
    super.loadFrom(device);
    if (device instanceof Device) {
      this.connectionInfo = device.connectionInfo;
    }
  }
}

export interface ConnectionInfo {
  host: string;
  port: number;
}

export interface SavedDeviceInfo extends SavedDeviceInfoBase {
  connectionInfo: ConnectionInfo;
}
